"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _antd = require("antd");
var _react = _interopRequireWildcard(require("react"));
var _data = _interopRequireDefault(require("./data"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var initialTargetKeys = _data.default.filter(function (item) {
  return +item.key > 10;
}).map(function (item) {
  return item.key;
});
var Demo = function Demo() {
  var _useState = (0, _react.useState)(initialTargetKeys),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    targetKeys = _useState2[0],
    setTargetKeys = _useState2[1];
  var _useState3 = (0, _react.useState)(['1', '2']),
    _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
    selectedKeys = _useState4[0],
    setSelectedKeys = _useState4[1];
  var onScroll = function onScroll() {};
  return /*#__PURE__*/_react.default.createElement(_antd.Transfer, {
    dataSource: _data.default,
    titles: ['Source', 'Target'],
    targetKeys: targetKeys,
    selectedKeys: selectedKeys,
    onChange: function onChange(nextTargetKeys) {
      setTargetKeys(nextTargetKeys);
    },
    onSelectChange: function onSelectChange(sourceSelectedKeys, targetSelectedKeys) {
      setSelectedKeys([].concat((0, _toConsumableArray2.default)(sourceSelectedKeys), (0, _toConsumableArray2.default)(targetSelectedKeys)));
    },
    onScroll: onScroll,
    render: function render(item) {
      return item.title;
    }
  });
};
var componentDemo = {
  demo: /*#__PURE__*/_react.default.createElement(Demo, null),
  tokens: ['controlItemBgActiveHover', 'controlItemBgActive', 'colorBgContainer'],
  key: 'default'
};
var _default = exports.default = componentDemo;